import { API } from "aws-amplify";

 export const handleGetSavedTemplates=async(facilityId = null)=>{
        try {
          const queryStringParameters = facilityId ? { facilityId } : {};
          const response = await API.get('Newsletterapp-user-templates', '/newsletter-user-templates', {
            response: true,
            queryStringParameters,
          });
           return response.data.data;
        } catch (error) {
            console.log("error getting Newsletter user templates",error);
          return [];
        }
       }
